function isVolumeCompatible(viewport) {
    return Boolean(viewport &&
        typeof viewport.setVolumes ===
            'function' &&
        typeof viewport.addVolumes === 'function');
}
export default isVolumeCompatible;
